import { CHANGE_SETTING, TOGGLE_SETTING } from "../actions/actions";

export interface SettingReducerTypes {
  isFixed: boolean;
  isCollapsed: boolean;
  isBoxed: boolean;
  isFloat: boolean;
  asideHover: boolean;
  asideScrollbar: boolean;
  isCollapsedText: boolean;
  offsidebarOpen: boolean;
  asideToggled: boolean;
  showUserBlock: boolean;
  horizontal: boolean;
  useFullLayout: boolean;
  hiddenFooter: boolean;
  showCustomerName: boolean;
  splitItemsByTable: boolean;
  showHiddenDockets: boolean;
  showTableServiceDockets: boolean;
  showCounterServiceDockets: boolean;
  showPickupDockets: boolean;
  showVacatedBookingDockets: boolean;
}

const initialSettings = {
  /* Layout fixed. Scroll content only */
  isFixed: true,
  /* Sidebar collapsed */
  isCollapsed: false,
  /* Boxed layout */
  isBoxed: false,
  /* Floating sidebar */
  isFloat: false,
  /* Sidebar show menu on hover only */
  asideHover: false,
  /* Show sidebar scrollbar (dont' hide it) */
  asideScrollbar: false,
  /* Sidebar collapsed with big icons and text */
  isCollapsedText: false,
  /* Toggle for the offsidebar */
  offsidebarOpen: false,
  /* Toggle for the sidebar offcanvas (mobile) */
  asideToggled: false,
  /* Toggle for the sidebar user block */
  showUserBlock: false,
  /* Enables layout horizontal */
  horizontal: false,
  /* Full size layout */
  useFullLayout: false,
  /* Hide footer */
  hiddenFooter: false,
  /* Show Customer Name */
  showCustomerName: true,
  splitItemsByTable: false,
  showHiddenDockets: false,
  showTableServiceDockets: true,
  showCounterServiceDockets: true,
  showPickupDockets: true,
  showVacatedBookingDockets: true,
} as SettingReducerTypes;

const settingsReducer = (state = initialSettings, action) => {
  switch (action.type) {
    case TOGGLE_SETTING:
      return {
        ...state,
        [action.name]: !state[action.name],
      };
    case CHANGE_SETTING:
      return {
        ...state,
        [action.name]: action.value,
      };
    default:
      return state;
  }
};

export default settingsReducer;
